import { render, staticRenderFns } from "./title-bubble.vue?vue&type=template&id=1a55b355&scoped=true&"
import script from "./title-bubble.vue?vue&type=script&lang=js&"
export * from "./title-bubble.vue?vue&type=script&lang=js&"
import style0 from "./title-bubble.vue?vue&type=style&index=0&id=1a55b355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a55b355",
  null
  
)

export default component.exports